export default __webpack_public_path__ + "static/media/applePay.fbefb9c0.png";